module.exports = __webpack_public_path__ + "assets/52e970a2e319892d05edc47f62cdfd0e.mp3";